// Centralized constants/config for MyHeritage feature
// Update MYHERITAGE_BASE_PATH to change the root route for the experience
import { colors } from '@fs/zion-ui'

export const MYHERITAGE_BASE_PATH = '/heritage'

export const DEFAULT_VISITOR_COUNTRY = 'US'

// Zion colors palette for the chart
export const CHART_COLORS = [
  colors.blue50,
  colors.green50,
  colors.red50,
  colors.yellow60,
  colors.purple50,
  colors.yellow40,
  colors.blue70,
  colors.red40,
  colors.purple70,
  colors.green30,
]

// Ring diameter = RADIUS*2 = 470 SVG units.
// At 1920px wide, the chart section is ~860px; SVG_WIDTH=1250 → scale=860/1250=0.688
// ring = 470 × 0.688 ≈ 323px — too small. We need a wider chart section or larger RADIUS.
//
// The chart flex section takes ~55% of the 1760px max-width content = ~968px.
// With SVG_WIDTH=1250: scale = 968/1250 = 0.774 → ring = 470 × 0.774 ≈ 364px still small.
//
// Solution: narrow SVG_WIDTH so the ring fills more of the rendered space.
// SVG_WIDTH=880: scale = 968/880 = 1.10 → ring = 470 × 1.10 = 517px (too big)
// SVG_WIDTH=1020: scale = 968/1020 = 0.949 → ring = 470 × 0.949 ≈ 446px (close)
// SVG_WIDTH=960: scale = 968/960 = 1.008 → ring ≈ 473px ✓
export const SVG_WIDTH = 960
export const SVG_HEIGHT = 700
export const CX = SVG_WIDTH / 2 // 480
export const CY = SVG_HEIGHT / 2 // 350
export const RADIUS = 235
export const LABEL_SPACING = 40
